import { AUTH_STORE_NAMESPACE } from '../config'
import * as storage from './storage'

/**
 * Removes the access token that older versions of the app saved.
 *
 * The app used to keep its own copy of the token in localStorage and send it
 * after it had expired. Now every request reads the token from the Amplify
 * session, so the copy is never read. This removes it from browsers that still
 * have it.
 */
export const clearLegacyAuthStoreData = () => {
  storage.removeItem(AUTH_STORE_NAMESPACE)
}
